import { Button, IconNode, ToolTip, Typography } from '@components/base';
import css from './index.module.scss';
import { useEffect, useState } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import {
  calculateCFRPrice,
  calculateCIFPrice,
  calculateExWorksPrice,
  calculateCMValues,
  EMPTY_CM_VALUES,
  ICMValues,
  calculateFobPrice,
  calculateQuoteCost,
  calculateQuotedPrice,
  convertPricePerUnit,
  convertWeight,
  roundTo2
} from '@helpers/utils';
import Images from '@assets/images';
import QuoteProductDetails from '../../../quote-product-details';
import { createFilterOptions } from '@mui/material';
import QuoteBaseExWorksPrice from '../../../quote-base-exworks';
import QuoteFOBCFRPrice from '../../../quote-fob-cfr';
import { TextField } from '@components/common';
import QuotePackageWrapper from '../../../quote-package-wrapper';
import { DEFAULT_PRIMARY_UNIT } from '../../../helper';
import QuoteCountryField from '@components/common/quote-wrapper/components/quote-country-field';

const filter = createFilterOptions<any>();

const QuoteProductFields = (props: any) => {
  const {
    isEnquiry,
    isEdit,
    fields,
    handleAddProductFields,
    handleDuplicateProductField,
    remove,
    quoteIndex,
    selectedWeightSystemChildOptions,
    selectedCurrency,
    filterProductOptions,
    productOptions,
    filterState,
    product,
    incoTermsWatch,
    primaryUnitWatch,
    currency1Watch,
    fxRateWatch,
    totalLocalFreightWatch,
    totalLocalFreightCurrencyWatch,
    totalPortAndClearanceExpensesWatch,
    totalPortAndClearanceExpensesCurrencyWatch,
    totalFreightWatch,
    totalFreightCurrencyWatch,
    totalWeightWatch,
    totalWeightUnitWatch,
    switchBlCostWatch,
    switchBlCostCurrencyWatch,
    financeCostWatch,
    discountWatch,
    insuranceCostWatch
  } = props;

  return (
    <main className={css.container}>
      {fields.map((item: any, index: number) => {
        const handleDeleteProduct = () => {
          remove(index);
        };
        return (
          <ProductFields
            key={index}
            isEdit={isEdit}
            index={index}
            quoteIndex={quoteIndex}
            filterState={filterState}
            handleDeleteProduct={handleDeleteProduct}
            selectedWeightSystemChildOptions={selectedWeightSystemChildOptions}
            selectedCurrency={selectedCurrency}
            filterProductOptions={filterProductOptions}
            productOptions={productOptions}
            handleDuplicateProductField={handleDuplicateProductField}
            fieldLength={fields.length}
            product={product}
            isExpanded={`${product}.${index}.isExpanded`}
            productName={`${product}.${index}.productName`}
            dealQuantity={`${product}.${index}.dealQuantity`}
            dealQuantityUnit={`${product}.${index}.dealQuantityUnit`}
            productPackaging={`${product}.${index}.productPackaging`}
            moq={`${product}.${index}.moq`}
            moqUnit={`${product}.${index}.moqUnit`}
            basePrice={`${product}.${index}.base_price.value`}
            basePriceCurrency={`${product}.${index}.base_price.currency`}
            finalExWorksPrice={`${product}.${index}.final_exWorks_price.value`}
            finalExWorksPriceCurrency={`${product}.${index}.final_exWorks_price.currency`}
            exWorksPriceManualOverride={`${product}.${index}.final_exWorks_price.manualOverride`}
            fobPrice={`${product}.${index}.fob_price.value`}
            fobPriceCurrency={`${product}.${index}.fob_price.currency`}
            fobPriceManualOverride={`${product}.${index}.fob_price.manualOverride`}
            cfrPrice={`${product}.${index}.cfr_price.value`}
            cfrPriceCurrency={`${product}.${index}.cfr_price.currency`}
            cfrPriceManualOverride={`${product}.${index}.cfr_price.manualOverride`}
            cifPrice={`${product}.${index}.cif_price.value`}
            cifPriceCurrency={`${product}.${index}.cif_price.currency`}
            cifPriceManualOverride={`${product}.${index}.cif_price.manualOverride`}
            finalQuoteSellingPrice={`${product}.${index}.finalQuote_selling_price.value`}
            finalQuoteSellingPriceWeightUnit={`${product}.${index}.finalQuote_selling_price.weightUnit`}
            finalQuoteSellingPriceManualOverride={`${product}.${index}.finalQuote_selling_price.manualOverride`}
            additionalCost={`${product}.${index}.additionalCost.value`}
            additionalCostCurrency={`${product}.${index}.additionalCost.currency`}
            profitMarginExpected={`${product}.${index}.profitMarginExpected`}
            countryOfOrigin={`${product}.${index}.countryOfOrigin`}
            materialLocationCountry={`${product}.${index}.materialLocationCountry`}
            incoTermsWatch={incoTermsWatch}
            primaryUnitWatch={primaryUnitWatch}
            currency1Watch={currency1Watch}
            fxRateWatch={fxRateWatch}
            totalLocalFreightWatch={totalLocalFreightWatch}
            totalLocalFreightCurrencyWatch={totalLocalFreightCurrencyWatch}
            totalPortAndClearanceExpensesWatch={totalPortAndClearanceExpensesWatch}
            totalPortAndClearanceExpensesCurrencyWatch={totalPortAndClearanceExpensesCurrencyWatch}
            totalFreightWatch={totalFreightWatch}
            totalFreightCurrencyWatch={totalFreightCurrencyWatch}
            totalWeightWatch={totalWeightWatch}
            totalWeightUnitWatch={totalWeightUnitWatch}
            switchBlCostWatch={switchBlCostWatch}
            switchBlCostCurrencyWatch={switchBlCostCurrencyWatch}
            financeCostWatch={financeCostWatch}
            discountWatch={discountWatch}
            insuranceCostWatch={insuranceCostWatch}
            isEnquiry={isEnquiry}
            basePriceWeightUnit={`${product}.${index}.base_price.weightUnit`}
            fobPriceWeightUnit={`${product}.${index}.fob_price.weightUnit`}
            cifPriceWeightUnit={`${product}.${index}.cif_price.weightUnit`}
            cfrPriceWeightUnit={`${product}.${index}.cfr_price.weightUnit`}
            finalExWorksPriceWeightUnit={`${product}.${index}.final_exWorks_price.weightUnit`}
          />
        );
      })}
      {isEnquiry && (
        <Button variant="outlined-secondary" onClick={handleAddProductFields}>
          Add Product
        </Button>
      )}
    </main>
  );
};

export default QuoteProductFields;

const ProductFields = (props: any) => {
  const {
    isEnquiry,
    isEdit,
    index,
    quoteIndex,
    filterState,
    handleDeleteProduct,
    selectedWeightSystemChildOptions,
    selectedCurrency,
    filterProductOptions,
    productOptions,
    handleDuplicateProductField,
    fieldLength,
    product,
    isExpanded,
    productName,
    dealQuantity,
    dealQuantityUnit,
    productPackaging,
    moq,
    moqUnit,
    basePrice,
    basePriceCurrency,
    finalExWorksPrice,
    finalExWorksPriceCurrency,
    exWorksPriceManualOverride,
    fobPrice,
    fobPriceCurrency,
    fobPriceManualOverride,
    cfrPrice,
    cfrPriceCurrency,
    cfrPriceManualOverride,
    cifPrice,
    cifPriceCurrency,
    cifPriceManualOverride,
    finalQuoteSellingPrice,
    finalQuoteSellingPriceWeightUnit,
    finalQuoteSellingPriceManualOverride,
    additionalCost,
    additionalCostCurrency,
    profitMarginExpected,
    countryOfOrigin,
    materialLocationCountry,
    incoTermsWatch,
    primaryUnitWatch,
    currency1Watch,
    fxRateWatch,
    totalLocalFreightWatch,
    totalLocalFreightCurrencyWatch,
    totalPortAndClearanceExpensesWatch,
    totalPortAndClearanceExpensesCurrencyWatch,
    totalFreightWatch,
    totalFreightCurrencyWatch,
    totalWeightWatch,
    totalWeightUnitWatch,
    switchBlCostWatch,
    switchBlCostCurrencyWatch,
    financeCostWatch,
    discountWatch,
    insuranceCostWatch,
    basePriceWeightUnit,
    fobPriceWeightUnit,
    cifPriceWeightUnit,
    cfrPriceWeightUnit,
    finalExWorksPriceWeightUnit
  } = props;

  const { mtt, fcl, consolidation } = filterState;

  const {
    control,
    setValue,
    getValues,
    formState: { dirtyFields },
    resetField
  } = useFormContext();
  const [cmValues, setCmValues] = useState<ICMValues>(EMPTY_CM_VALUES);
  // Not part of the payload; kept in form state so the cost calculator can show CM1 / CM2
  const cmValuesField = profitMarginExpected.replace(/profitMarginExpected$/, 'cmValues');

  const isExpandedWatch = useWatch({ control, name: isExpanded });
  const productNameWatch = useWatch({ control, name: productName });
  const dealQuantityWatch = useWatch({ control, name: dealQuantity });
  const dealQuantityUnitWatch = useWatch({ control, name: dealQuantityUnit });
  const productPackagingWatch = useWatch({ control, name: productPackaging });
  const moqWatch = useWatch({ control, name: moq });
  const moqUnitWatch = useWatch({ control, name: moqUnit });
  const basePriceWatch = useWatch({ control, name: basePrice });
  const basePriceCurrencyWatch = useWatch({ control, name: basePriceCurrency });
  const finalExWorksPriceWatch = useWatch({ control, name: finalExWorksPrice });
  const finalExWorksPriceCurrencyWatch = useWatch({ control, name: finalExWorksPriceCurrency });
  const exWorksPriceManualOverrideWatch = useWatch({ control, name: exWorksPriceManualOverride });
  const fobPriceWatch = useWatch({ control, name: fobPrice });
  const fobPriceCurrencyWatch = useWatch({ control, name: fobPriceCurrency });
  const fobManualOverrideWatch = useWatch({ control, name: fobPriceManualOverride });
  const cfrPriceWatch = useWatch({ control, name: cfrPrice });
  const cfrPriceCurrencyWatch = useWatch({ control, name: cfrPriceCurrency });
  const cfrManualOverrideWatch = useWatch({ control, name: cfrPriceManualOverride });
  const cifPriceWatch = useWatch({ control, name: cifPrice });
  const cifPriceCurrencyWatch = useWatch({ control, name: cifPriceCurrency });
  const cifManualOverrideWatch = useWatch({ control, name: cifPriceManualOverride });
  const finalQuoteSellingPriceWatch = useWatch({ control, name: finalQuoteSellingPrice });
  const finalQuoteSellingPriceWeightUnitWatch = useWatch({
    control,
    name: finalQuoteSellingPriceWeightUnit
  });
  const finalQuoteSellingPriceManualOverrideWatch = useWatch({
    control,
    name: finalQuoteSellingPriceManualOverride
  });
  const additionalCostWatch = useWatch({ control, name: additionalCost });
  const additionalCostCurrencyWatch = useWatch({ control, name: additionalCostCurrency });
  const profitMarginExpectedWatch = useWatch({ control, name: profitMarginExpected });
  const basePriceWeightUnitWatch = useWatch({
    control,
    name: basePriceWeightUnit
  });

  const fobPriceWeightUnitWatch = useWatch({
    control,
    name: fobPriceWeightUnit
  });

  const cifPriceWeightUnitWatch = useWatch({
    control,
    name: cifPriceWeightUnit
  });

  const cfrPriceWeightUnitWatch = useWatch({
    control,
    name: cfrPriceWeightUnit
  });

  const exWorksPriceWeightUnitWatch = useWatch({
    control,
    name: finalExWorksPriceWeightUnit
  });

  //Ex-Works Price Calculation
  useEffect(() => {
    if (exWorksPriceManualOverrideWatch) return;

    if (!basePriceWatch || !fxRateWatch) {
      return;
    }

    const exWorksPrice = calculateExWorksPrice(
      basePriceCurrencyWatch,
      currency1Watch,
      basePriceWatch,
      fxRateWatch || 1,
      finalExWorksPriceCurrencyWatch,
      basePriceWeightUnitWatch,
      exWorksPriceWeightUnitWatch,
      primaryUnitWatch
    );
    setValue(finalExWorksPrice, exWorksPrice);
  }, [
    basePriceWatch,
    fxRateWatch,
    currency1Watch,
    basePriceCurrencyWatch,
    finalExWorksPriceCurrencyWatch,
    exWorksPriceManualOverrideWatch,
    basePriceWeightUnitWatch,
    exWorksPriceWeightUnitWatch,
    primaryUnitWatch
  ]);

  // FOB Price Calculation
  useEffect(() => {
    if (fobManualOverrideWatch) return;

    if (!totalWeightWatch || !totalWeightUnitWatch) {
      return;
    }

    const dealQuantityInPrimaryUnit = convertWeight(
      dealQuantityWatch || 0,
      dealQuantityUnitWatch?.value || '',
      primaryUnitWatch?.value
    );

    const totalWeightInPrimaryUnit = convertWeight(
      totalWeightWatch || 0,
      totalWeightUnitWatch?.value,
      primaryUnitWatch?.value
    );

    const weightToUse =
      dealQuantityInPrimaryUnit === 0
        ? totalWeightInPrimaryUnit
        : totalWeightInPrimaryUnit === 0
        ? dealQuantityInPrimaryUnit
        : Math.min(dealQuantityInPrimaryUnit, totalWeightInPrimaryUnit);

    const finalFobPrice = calculateFobPrice(
      totalLocalFreightWatch,
      totalLocalFreightCurrencyWatch,
      totalPortAndClearanceExpensesWatch,
      totalPortAndClearanceExpensesCurrencyWatch,
      weightToUse,
      fxRateWatch || 1,
      currency1Watch,
      fobPriceCurrencyWatch,
      finalExWorksPriceWatch,
      finalExWorksPriceCurrencyWatch,
      exWorksPriceWeightUnitWatch,
      fobPriceWeightUnitWatch,
      primaryUnitWatch
    );
    const newValue = finalFobPrice;
    const currentValue = getValues(fobPrice);

    if (newValue !== currentValue) {
      setValue(fobPrice, finalFobPrice);
    } else return;
  }, [
    totalLocalFreightWatch,
    totalLocalFreightCurrencyWatch,
    totalPortAndClearanceExpensesWatch,
    totalPortAndClearanceExpensesCurrencyWatch,
    totalWeightWatch,
    totalWeightUnitWatch,
    finalExWorksPriceWatch,
    primaryUnitWatch,
    fobPriceCurrencyWatch,
    fxRateWatch,
    finalExWorksPriceCurrencyWatch,
    fobManualOverrideWatch,
    dealQuantityUnitWatch,
    dealQuantityWatch,
    exWorksPriceWeightUnitWatch,
    fobPriceWeightUnitWatch
  ]);

  // CFR Price
  useEffect(() => {
    if (cfrManualOverrideWatch) return;
    if (!fxRateWatch || !totalWeightWatch || !totalWeightUnitWatch) {
      return;
    }

    const dealQuantityInPrimaryUnit = convertWeight(
      dealQuantityWatch || 0,
      dealQuantityUnitWatch?.value || '',
      primaryUnitWatch?.value
    );

    const totalWeightInPrimaryUnit = convertWeight(
      totalWeightWatch || 0,
      totalWeightUnitWatch?.value,
      primaryUnitWatch?.value
    );

    const weightToUse =
      dealQuantityInPrimaryUnit === 0
        ? totalWeightInPrimaryUnit
        : totalWeightInPrimaryUnit === 0
        ? dealQuantityInPrimaryUnit
        : Math.min(dealQuantityInPrimaryUnit, totalWeightInPrimaryUnit);

    const finalCfrPrice = calculateCFRPrice(
      totalFreightWatch,
      totalFreightCurrencyWatch,
      weightToUse,
      fxRateWatch,
      cfrPriceCurrencyWatch,
      currency1Watch,
      fobPriceWatch,
      fobPriceCurrencyWatch,
      fobPriceWeightUnitWatch,
      cfrPriceWeightUnitWatch,
      primaryUnitWatch
    );
    const currentValue = getValues(cfrPrice);
    if (finalCfrPrice == currentValue) {
      return;
    }
    setValue(cfrPrice, finalCfrPrice);
  }, [
    fobPriceCurrencyWatch,
    fobPriceWatch,
    totalWeightWatch,
    totalWeightUnitWatch,
    totalFreightWatch,
    totalFreightCurrencyWatch,
    cfrPriceCurrencyWatch,
    primaryUnitWatch,
    switchBlCostWatch,
    switchBlCostCurrencyWatch,
    cfrManualOverrideWatch,
    dealQuantityUnitWatch,
    dealQuantityWatch,
    fobPriceWeightUnitWatch,
    cfrPriceWeightUnitWatch
  ]);

  // CIF Price Calculation
  useEffect(() => {
    if (cifManualOverrideWatch) return;

    if (!fxRateWatch) {
      return;
    }
    const finalCIFPrice = calculateCIFPrice(
      fxRateWatch || 1,
      currency1Watch,
      cfrPriceWatch,
      cfrPriceCurrencyWatch,
      insuranceCostWatch,
      cifPriceCurrencyWatch,
      cfrPriceWeightUnitWatch,
      cifPriceWeightUnitWatch,
      primaryUnitWatch
    );
    const currentValue = getValues(cifPrice);
    if (finalCIFPrice == currentValue) {
      return;
    }
    setValue(cifPrice, finalCIFPrice);
  }, [
    insuranceCostWatch,
    cfrPriceWatch,
    cifPriceCurrencyWatch,
    cfrPriceCurrencyWatch,
    cifManualOverrideWatch,
    cfrPriceWeightUnitWatch,
    cifPriceWeightUnitWatch,
    primaryUnitWatch
  ]);

  // Quote Selling Price Calculation
  useEffect(() => {
    if (!fxRateWatch) {
      return;
    }
    const weightUnit = getValues(finalQuoteSellingPriceWeightUnit);
    let priceBasedOnIncoterm = 0;
    let currencyBasedOnIncoterm;
    let weightUnitBasedOnIncoterm = DEFAULT_PRIMARY_UNIT;

    switch (incoTermsWatch?.value) {
      case 'EXW':
        priceBasedOnIncoterm = Number(finalExWorksPriceWatch || 0);
        currencyBasedOnIncoterm = finalExWorksPriceCurrencyWatch;
        weightUnitBasedOnIncoterm = exWorksPriceWeightUnitWatch;
        break;
      case 'FOB':
        priceBasedOnIncoterm = Number(fobPriceWatch || 0);
        currencyBasedOnIncoterm = fobPriceCurrencyWatch;
        weightUnitBasedOnIncoterm = fobPriceWeightUnitWatch;
        break;
      case 'CFR':
        priceBasedOnIncoterm = Number(cfrPriceWatch || 0);
        currencyBasedOnIncoterm = cfrPriceCurrencyWatch;
        weightUnitBasedOnIncoterm = cfrPriceWeightUnitWatch;
        break;
      default:
        priceBasedOnIncoterm = Number(cifPriceWatch || 0);
        currencyBasedOnIncoterm = cifPriceCurrencyWatch;
        weightUnitBasedOnIncoterm = cifPriceWeightUnitWatch;
        break;
    }
    const QuoteSellingPrice = calculateQuotedPrice(
      priceBasedOnIncoterm,
      currencyBasedOnIncoterm,
      weightUnitBasedOnIncoterm,
      additionalCostWatch,
      additionalCostCurrencyWatch,
      switchBlCostWatch,
      switchBlCostCurrencyWatch,
      financeCostWatch,
      profitMarginExpectedWatch,
      discountWatch,
      0, // tariff (not applicable for consolidation)
      currency1Watch,
      fxRateWatch ?? 1,
      primaryUnitWatch,
      weightUnit
    );
    setValue(finalQuoteSellingPrice, QuoteSellingPrice);

    const quoteCost = calculateQuoteCost(
      priceBasedOnIncoterm,
      currencyBasedOnIncoterm,
      weightUnitBasedOnIncoterm,
      additionalCostWatch,
      additionalCostCurrencyWatch,
      switchBlCostWatch,
      switchBlCostCurrencyWatch,
      0, // tariff (not applicable for consolidation)
      currency1Watch,
      fxRateWatch ?? 1,
      primaryUnitWatch
    );
    const dealQuantityInPrimaryUnit = convertWeight(
      dealQuantityWatch || 0,
      dealQuantityUnitWatch?.value,
      primaryUnitWatch?.value
    );
    const quoteCMValues = calculateCMValues(
      quoteCost,
      // SP as quoted: rounded to 2 decimals in the selling price unit, then converted
      convertPricePerUnit(roundTo2(QuoteSellingPrice), weightUnit?.value, primaryUnitWatch?.value),
      financeCostWatch,
      dealQuantityInPrimaryUnit
    );
    setCmValues(quoteCMValues);
    setValue(cmValuesField, quoteCMValues);
  }, [
    cifPriceWatch,
    cifPriceCurrencyWatch,
    additionalCostWatch,
    additionalCostCurrencyWatch,
    financeCostWatch,
    profitMarginExpectedWatch,
    discountWatch,
    switchBlCostWatch,
    switchBlCostCurrencyWatch,
    incoTermsWatch,
    primaryUnitWatch,
    finalQuoteSellingPriceWeightUnitWatch,
    dealQuantityWatch,
    dealQuantityUnitWatch
  ]);

  const handleProductSelection = (event: any, param: any) => {
    if (param) {
      setValue(productName, param);
    } else {
      setValue(productName, null);
    }
  };

  const toggleProductExpand = () => {
    setValue(isExpanded, !isExpandedWatch);
  };

  return (
    <main className={css.mainWrapper}>
      <div className={css.headerWrapper}>
        <div className={css.headerText} onClick={() => toggleProductExpand()}>
          Product {index + 1}
        </div>
        <div className={css.headerIcons}>
          {isEnquiry && (
            <Button variant="text" onClick={() => handleDuplicateProductField(quoteIndex, index)}>
              Duplicate Product
            </Button>
          )}
          {isEnquiry && (
            <ToolTip title="Delete">
              <div>
                <IconNode
                  src={fieldLength > 1 ? Images.deleteRed : Images.delete}
                  onClick={() => {
                    fieldLength > 1 ? handleDeleteProduct() : undefined;
                  }}
                />
              </div>
            </ToolTip>
          )}

          <ToolTip title={isExpandedWatch ? 'Collapse' : 'Expand'}>
            <div>
              <IconNode
                src={isExpandedWatch ? Images.arrowUpBig : Images.arrowDownBig}
                onClick={() => toggleProductExpand()}
              />
            </div>
          </ToolTip>
        </div>
      </div>
      {isExpandedWatch && (
        <>
          <QuoteProductDetails
            productName={productName}
            productOptions={productOptions}
            filterProductOptions={filterProductOptions}
            handleProductSelection={handleProductSelection}
            filter={filter}
            dealQuantity={dealQuantity}
            dealQuantityUnit={dealQuantityUnit}
            selectedWeightSystemChildOptions={selectedWeightSystemChildOptions}
            productPackaging={productPackaging}
            moq={moq}
            moqUnit={moqUnit}
            productNameDisable={isEdit}
          />

          {!mtt && (
            <QuoteBaseExWorksPrice
              primaryUnitWatch={primaryUnitWatch}
              basePrice={basePrice}
              basePriceCurrency={basePriceCurrency}
              finalExWorksPrice={finalExWorksPrice}
              finalExWorksPriceCurrency={finalExWorksPriceCurrency}
              selectedCurrency={selectedCurrency}
              exWorksPriceManualOverride={exWorksPriceManualOverride}
              fobPriceManualOverride={fobPriceManualOverride}
              cfrPriceManualOverride={cfrPriceManualOverride}
              cifPriceManualOverride={cifPriceManualOverride}
              basePriceWeightUnitWatch={basePriceWeightUnitWatch}
              finalExWorksPriceWeightUnitWatch={exWorksPriceWeightUnitWatch}
            />
          )}

          <QuoteFOBCFRPrice
            primaryUnitWatch={primaryUnitWatch}
            fobPrice={fobPrice}
            fobPriceCurrency={fobPriceCurrency}
            cfrPrice={cfrPrice}
            cfrPriceCurrency={cfrPriceCurrency}
            selectedCurrency={selectedCurrency}
            fobPriceManualOverride={fobPriceManualOverride}
            cfrPriceManualOverride={cfrPriceManualOverride}
            cifPriceManualOverride={cifPriceManualOverride}
            finalExWorksPrice={finalExWorksPrice}
            basePrice={basePrice}
            fobPriceWeightUnitWatch={fobPriceWeightUnitWatch}
            cifPriceWeightUnitWatch={cifPriceWeightUnitWatch}
          />

          <div className={css.rowWrapper}>
            <QuotePackageWrapper
              label={
                <span>
                  CIF Price
                  {cifPriceWeightUnitWatch && (
                    <Typography variant="label">
                      {' '}
                      ( Per {cifPriceWeightUnitWatch?.label} )
                    </Typography>
                  )}
                </span>
              }
              unitPlaceholder="Currency"
              inputPlaceholder="CIF Price"
              input={cifPrice}
              unit={cifPriceCurrency}
              control={control}
              unitOptions={selectedCurrency}
              currency
              inputOnChange={() => {
                setValue(cifPriceManualOverride, true, { shouldDirty: true });
                setValue(finalExWorksPrice, 0);
                setValue(basePrice, 0);
                setValue(fobPrice, 0);
                setValue(cfrPrice, 0);
              }}
            />
            <QuotePackageWrapper
              label={
                <span>
                  Additional Cost
                  {primaryUnitWatch && (
                    <Typography variant="label"> ( Per {primaryUnitWatch?.label} )</Typography>
                  )}
                </span>
              }
              unitPlaceholder="Currency"
              inputPlaceholder="Additional Cost"
              input={additionalCost}
              unit={additionalCostCurrency}
              control={control}
              unitOptions={selectedCurrency}
              currency
            />
          </div>

          <div className={css.rowWrapper}>
            <Controller
              name={profitMarginExpected}
              control={control}
              render={({ field, fieldState }) => (
                <TextField
                  {...field}
                  label={<span>Expected Profit Margin %</span>}
                  required
                  placeholder="Enter value in percentage"
                  error={fieldState.invalid}
                  helperText={fieldState.error?.message}
                />
              )}
            />
            <QuoteCountryField name={countryOfOrigin} label="Country of Origin" />
          </div>
          <div className={css.rowWrapper}>
            <QuoteCountryField name={materialLocationCountry} label="Material Location Country" />
            <div />
          </div>
        </>
      )}
    </main>
  );
};
